export default __webpack_public_path__ + "static/media/icon-other-share.9325ee52.svg";